export default __webpack_public_path__ + "c471f593443c813ab2317b9d0d654346.svg";